import React from "react"
import classnames from "classnames"

import * as styles from "./layout.module.scss"
import Footer from "../footer/footer";
import Header from "../header/header";

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

const Layout = ({ children, className }: LayoutProps) => {
  return (
    <>
      <Header />
      <main className={classnames(styles.root, className)}>
        {children}
      </main>
      <Footer />
    </>
  )
}

export default Layout
